<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
          <vx-card v-can="'view-forecast-tool'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
                 :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <customer-dropdown
                v-on:onInput="value => filters['customer_id'] = value.id"
                :selected_customer_data="filters['customer_id']"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Search Lead</label>
              <v-select name="customer_lead_id"
                                class="is-label-placeholder pb-5 w-full rounded-full"
                                label="company_name" v-model="filters['customer_lead_id']"
                                :options="marketing_leads" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.id">
                                <template slot="option" slot-scope="option">
                                  {{ option.company_name || option.email }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                  {{ option.company_name || option.email }}
                                </template>
            </v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Formulations</label>
              <v-select :clearable="true" name="formulations" placeholder="" label="formulation_code"
                        v-model="filters['formulation_id']"
                        :options="formulations"
                        :reduce="option => option.id"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">From</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date From" v-model="filters['from_date']"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">From</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date To" v-model="filters['to_date']"/>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={ 
                          customer_id: null,
                          customer_lead_id: null,
                          formulation_id: null,
                          from_date: null,
                          to_date: null
                  }">CLEAR
              </vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card title="FORECAST TOOL">
          <template slot="actions">
            <vs-button v-can="'view-forecast-tool'"
                       @click="downloadForecastDocument" class="mr-4" color="primary" type="filled">Download Forecast Document
            </vs-button>
            <vs-button v-can="'create-edit-forecast-tool'" @click="createForecast" class="mr-4" color="primary" type="filled">Create new Forecast
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4" v-can="'view-forecast-tool'">
            <vs-table
              id="forecast-list"
              :data="forecast_list"
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">
              <template slot="thead">
                <vs-th width="15%">CUSTOMER NAME</vs-th>
                <vs-th width="15%">CUSTOMER ACC NUMBER</vs-th>
                <vs-th width="50%">PRODUCTS</vs-th>
                <vs-th width="20%">ACTION</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="index" v-for="(tr, index) in data" @click.native="updateForecast(data[index])">
                  <vs-td :data="data[index].company_name">
                    {{ data[index].company_name || 'N/A' }}
                  </vs-td>
                  <vs-td :data="data[index].account_number">
                    <HyperLink :id="data[index].id" type="customer">{{ data[index].account_number }}</HyperLink>
                  </vs-td>
                  <vs-td :data="data[index].forecast_tools">
                    <span v-for="(tool, indextr) in data[index].forecast_tools" :key="indextr">
                      <HyperLink :id="tool.formulation_id" type="formulation">{{ tool.formulation_code || 'TBC' }}</HyperLink> <span v-if="index + 1 !== data[index].forecast_tools.length">,</span>
                    </span>
                  </vs-td>
                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View & update" position="left" v-can="'create-edit-forecast-tool'">
                        <vs-button
                          size="small" color="primary" @click.stop="updateForecast(data[index])" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
<!--            <vs-pagination-->
<!--              v-on:changeMaxItems="changePage"-->
<!--              :size-array="forecast_meta.total"-->
<!--              :max-items="perPage"-->
<!--              description-body="Rows per page"-->
<!--              description-connector="of"-->
<!--              description-title="Records"-->
<!--              description-->
<!--              :description-items="descriptionItems"-->
<!--              :total="(forecast_meta.last_page)? forecast_meta.last_page : 0"-->
<!--              v-model="page" class="p-5">-->
<!--            </vs-pagination>-->
          </div>
        </vx-card>
        <create-forecast ref="createForecast"/>
        <update-forecast ref="updateForecast" v-on:onClickAddNewProduct="onClickAddNewProduct" @refreshData="refreshData" />
        <download-forecast-document-pop-up ref="DownloadForecastDocumentPopUp" :filters="filters"/>
        <vs-prompt
          @cancel="activeSelectCustomerPrompt = false"
          @accept="onClickSelectCustomer"
          @close="activeSelectCustomerPrompt = false"
          title="Create Forecast Tool"
          accept-text="Confirm"
          color="primary"
          :active.sync="activeSelectCustomerPrompt">
          <div class="con-exemple-prompt">
            <div class="vx-row">
              <div class="vx-col w-full">
                <customer-dropdown
                  field_label="Select Customer"
                  v-on:onInput="value => selected_customer_obj = value ? value : null"
                  :selected_customer_data="selected_customer_obj"
                />
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full text-center">
                or
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <small class="mt-4">Select Customer Lead</small>
                  <v-select name="customer_id"
                                class="is-label-placeholder pb-5 w-full rounded-full"
                                label="company_name" v-model="selected_customer_obj"
                                :options="marketing_leads" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                                <template slot="option" slot-scope="option">
                                  {{ option.company_name || option.email }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                  {{ option.company_name || option.email }}
                                </template>
                  </v-select>
              </div>
            </div>
          </div>
        </vs-prompt>
      </div>
    </div>
  </div>
</template>

<script>
import {defaultPagination, perPageList} from "@/constants/config";
import {mapActions, mapGetters} from "vuex";
import Filter from '@/mixins/filter';
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment';
import CreateForecast from "@/components/popups/forecast-tool/CreateForecast";
import UpdateForecast from "@/components/popups/forecast-tool/UpdateForecast";
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from '@/mixins/ErrorMessages'
import 'flatpickr/dist/flatpickr.css'
import successMessage from "@/mixins/SuccessMessage";
import errorMessages from "@/mixins/ErrorMessages";
import DownloadForecastDocumentPopUp from "@/components/popups/forecast-tool/DownloadForecastDocumentPopUp";
import CustomerDropdown from "@/components/drop-down-filters/CustomerDropdown";

const FormulationsRepository = RepositoryFactory.get('formulations')
const CustomerRepository = RepositoryFactory.get('customer')
const ForecastRepository = RepositoryFactory.get('forecast')
const DropDownRepository = RepositoryFactory.get('drop_down')

export default {
  name: "ForecastList",
  components: {
    CustomerDropdown,
    DownloadForecastDocumentPopUp,
    CreateForecast,
    UpdateForecast,
    'v-select': vSelect,
    flatPickr,
  },
  data() {
    return {
      filters: { customer_id: null, customer_lead_id: null, formulation_id: null, from_date: null, to_date: null },
      page: 1,
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      formulations: [],
      activeSelectCustomerPrompt: false,
      selected_customer_obj: {},
      filterQuery: '',
      marketing_leads: []
    }
  },
  computed: {
    ...mapGetters({
      forecast_list: 'forecasts',
    })
  },
  async mounted() {
    await this.fetchCustomerLeads()
    await this.fetchForeCastList()
    await this.fetchFormulations()
    if (this.$route.query.customer_id ) {
        this.filters.customer_id = this.$route.query.customer_id
    }
    if (this.$route.query.create_lead ) {
        const find = this.marketing_leads.find((x) => x.id + '' === this.$route.query.create_lead)
        if(!!find) {
          await this.$refs.updateForecast.openPopup({ data: find, customer_type : 'lead' })
        }
        this.$router.push('/pages/forecasts')
    }
  },
  mixins: [successMessage,errorMessages],
  methods: {
    ...mapActions(['fetchAllForecasts']),
    refreshData() {
      this.fetchForeCastList()
    },
    async onClickSelectCustomer() {
      const customer_type = !!this.selected_customer_obj.account_number ? 'customer' : 'lead'
      let if_exists = null
      if(customer_type === 'customer') {
        if_exists = this.forecast_list.find((x) => x.account_number === this.selected_customer_obj.account_number)
      }
      if(customer_type === 'lead') {
        if_exists = this.forecast_list.find((x) => x.account_number === this.selected_customer_obj.code)
      }
      if(!if_exists) {
        await this.$refs.updateForecast.openPopup({ data: this.selected_customer_obj, customer_type })
      } else {
        await this.$refs.updateForecast.openPopup({ data: this.selected_customer_obj, customer_type })
      }
    },
    async fetchForeCastList() {
      try {
        await this.fetchAllForecasts({filterQuery: this.filterQuery})
      } catch (error) {

      }
    },
    async fetchFormulations() {
      this.$vs.loading();
      const {data} = (await DropDownRepository.getFormulationList()).data
      this.formulations = data
      this.$vs.loading.close()
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US')
    },
    filterQueryUpdate() {
      this.fetchForeCastList()
    },
    async createForecast() {
      this.activeSelectCustomerPrompt = true
    },
    async updateForecast(data){
      const customer_type = data.account_number.includes('MQL') ? 'lead' : 'customer'
      const row_data = {
        customer_type,
        data : {
            code: data.company_name.length > 0 ? data.company_name : data.account_number,
            company_name: data.company_name,
            id: data.id
        }
      }
      await this.$refs.updateForecast.openPopup(row_data)
    },
    async downloadForecastDocument(){
      await this.$refs.DownloadForecastDocumentPopUp.openPopup()
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    openStatusChangeConfirm(id){
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to Delete this forecast?',
        accept: this.deleteForecast,
        parameters: [id]
      })
    },
    async deleteForecast(id){
      this.$vs.loading();
      try {
        await ForecastRepository.deleteForecast(id[0])
        this.showSuccessMessage('Forecast create successfully');
        this.refreshData()
      }catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async onClickAddNewProduct(customer_data) {
      await this.$refs.createForecast.openPopup(customer_data)
    },
    async fetchCustomerLeads() {
        await this.$vs.loading()
        const { data } = await DropDownRepository.getCustomerLeadList()
        this.marketing_leads = data.data
        await this.$vs.loading.close()
    },
  },
  watch: {
    page() {
      this.fetchForeCastList()
    },
    perPage() {
      this.fetchForeCastList()
    },
    'filters': {
      handler (value) {
        clearTimeout(this.timer)
        this.filterQuery = ''
        const queries = []
        for (const filter in value) {
          if (this.filters[filter] && this.filters[filter] !== '') {
            if (this.filters[filter] instanceof Date) {
              queries.push(`${filter}=${encodeURIComponent(moment(this.filters[filter]).format('YYYY-MM-DD'))}`)
            } else {
              queries.push(`${filter}=${encodeURIComponent(this.filters[filter])}`)
            }
          }
        }
        if (queries.length > 0) this.filterQuery = queries.join('&')
        const that = this
        this.timer = setTimeout(function () {
          that.fetchForeCastList()
        }, 500)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
